function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 25,
  height: 25,
  rx: 4.5,
  fill: "none",
  stroke: "#860935"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6674 8.35674L19.2632 7.95305C18.8195 7.50844 18.0926 7.50844 17.6475 7.95305L10.7859 14.8157L8.35105 12.3818C7.90738 11.9377 7.17999 11.9377 6.73632 12.3823L6.33263 12.7855C5.88896 13.2296 5.88896 13.9565 6.33263 14.4007L9.97613 18.048C10.4203 18.4916 11.1472 18.4916 11.5913 18.048L19.6674 9.97194C20.1106 9.52779 20.1106 8.80088 19.6674 8.35674Z",
  fill: "#860935"
});

function SvgCheckboxChecked({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiByeD0iNC41IiBmaWxsPSJub25lIiBzdHJva2U9IiM4NjA5MzUiLz4KICA8cGF0aAogICAgZD0iTTE5LjY2NzQgOC4zNTY3NEwxOS4yNjMyIDcuOTUzMDVDMTguODE5NSA3LjUwODQ0IDE4LjA5MjYgNy41MDg0NCAxNy42NDc1IDcuOTUzMDVMMTAuNzg1OSAxNC44MTU3TDguMzUxMDUgMTIuMzgxOEM3LjkwNzM4IDExLjkzNzcgNy4xNzk5OSAxMS45Mzc3IDYuNzM2MzIgMTIuMzgyM0w2LjMzMjYzIDEyLjc4NTVDNS44ODg5NiAxMy4yMjk2IDUuODg4OTYgMTMuOTU2NSA2LjMzMjYzIDE0LjQwMDdMOS45NzYxMyAxOC4wNDhDMTAuNDIwMyAxOC40OTE2IDExLjE0NzIgMTguNDkxNiAxMS41OTEzIDE4LjA0OEwxOS42Njc0IDkuOTcxOTRDMjAuMTEwNiA5LjUyNzc5IDIwLjExMDYgOC44MDA4OCAxOS42Njc0IDguMzU2NzRaIgogICAgZmlsbD0iIzg2MDkzNSIKICAvPgo8L3N2Zz4K";
export { SvgCheckboxChecked as ReactComponent };